"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _button = require("@creditas-lab/button");

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var button = function button(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  padding: 0;\n  min-width: 0;\n  border: none;\n  width: auto;\n  height: auto;\n  color: ", ";\n\n  ", "\n\n  &:hover {\n    background: none;\n    border: none;\n  }\n"])), _styleUtilities.typography.sm(theme), _styleUtilities.typography.weight.md(theme), _styleUtilities.palette.brandPrimaryDefault(theme), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), _styleUtilities.typography.md(theme)));
};

var StyledButton = (0, _stylitas.styled)(_button.Button)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), button);
exports.Button = StyledButton;